import {controller, target} from '@github/catalyst'
import {TemplateInstance} from '@github/template-parts'

@controller('comment-actions-container')
class CommentActionsContainerElement extends HTMLElement {
  @target declare dialogTemplate: HTMLTemplateElement
  @target declare dialogContainer: HTMLDivElement

  displayDialog(event: Event) {
    const button = event.currentTarget as HTMLButtonElement
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const dialogId = button.getAttribute('data-dialog-id')!

    const dialogExist = this.dialogContainer.querySelector<HTMLDialogElement>(`#${dialogId}`)
    if (!dialogExist) {
      this.createDialog(dialogId, button)
    }
    this.showDialog(dialogId)
  }

  private createDialog(dialogId: string, button: HTMLButtonElement) {
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const title = button.getAttribute('data-title')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const src = button.getAttribute('data-src')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const size = button.getAttribute('data-size')!
    const newDialog = new TemplateInstance(this.dialogTemplate, {title, dialogId, src})

    this.dialogContainer.append(newDialog)
    if (size) {
      /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
      const dialog = this.querySelector<HTMLDialogElement>(`#${dialogId}`)!
      dialog.classList.remove('Overlay--size-medium')
      dialog.classList.add(`Overlay--size-${size}`)
    }
  }

  private showDialog(dialogId: string) {
    const dialog = this.querySelector<HTMLDialogElement>(`#${dialogId}`)
    if (dialog) {
      dialog.showModal()
    }
  }
}
